import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MaintenanceWindowGridDataProviderFactory } from '../factory/MaintenanceWindowGridDataProviderFactory';
import { MaintenanceWindowGridBaseDataProvider } from '../dataProvider/MaintenanceWindowGridBaseDataProvider';

export class MaintenanceWindowGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MaintenanceWindowGridDataProviderFactory;
  public dataProvider: MaintenanceWindowGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MaintenanceWindowGridDataProviderFactory(),
    });
  }

  /**
   * Remove records
   * @param params
   */
  async removeRecords(params: any): Promise<{ success: boolean }> {
    return this.dataProvider.removeRecords(params);
  }
}
